export default "__VITE_ASSET__HPnyMLwT__"